// @flow
import sortBy from 'lodash/sortBy';

declare function sortByOrder<TItem: string>(
    array: Array<TItem>,
    sortOrder: Array<string>
): Array<TItem>;

// eslint-disable-next-line no-redeclare
declare function sortByOrder<TItem: { [key: string]: any }>(
    array: Array<TItem>,
    sortOrder: Array<string>,
    sortKey: string
): Array<TItem>;

// eslint-disable-next-line no-redeclare, func-style
function sortByOrder(array, sortOrder, sortKey) {
    return sortBy(array, item =>
        sortOrder.findIndex(order => {
            return sortKey ? order === item[sortKey] : order === item;
        })
    );
}

export default sortByOrder;
